import { TypePayment } from '@/models/TypePayment';
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    PaymentStatus["DECLINED"] = "DECLINED";
    PaymentStatus["EXPIRED"] = "EXPIRED";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentStatus["CHARGED_BACK"] = "CHARGED_BACK";
    PaymentStatus["PRED_AUTHORIZED"] = "PRED_AUTHORIZED";
    PaymentStatus["VOIDED"] = "VOIDED";
    PaymentStatus["UNKNOWN"] = "UNKNOWN";
})(PaymentStatus || (PaymentStatus = {}));
export class PaymentDetails {
    constructor() {
        this.status = PaymentStatus.UNKNOWN;
        this.amount = 0;
        this.orderIdGateway = '';
        this.type = TypePayment.ND;
        this.totalDeposit = 0;
        this.authBank = '';
        this.fee = 0;
        this.cardBank = '';
        this.cardBrand = '';
        this.cardName = '';
    }
}
